const STORAGE_KEY = "tiny_provider";

const providerStorage = (() => {
  let provider: string | null = null;
  let isInitialized = false;

  // The provider only ever arrives on the URL once, on the redirect into the
  // app (?provider=samcart). Internal SPA navigation doesn't carry it, so a
  // hard reload on any URL without the param must fall back to what was
  // persisted on the first load, or gating (theme, nav, restricted routes)
  // silently resets to the default/unrestricted config.
  const initialize = (url: URL) => {
    if (isInitialized) return;
    const fromUrl = url.searchParams.get("provider");
    if (fromUrl) {
      sessionStorage.setItem(STORAGE_KEY, fromUrl);
      provider = fromUrl;
    } else {
      provider = sessionStorage.getItem(STORAGE_KEY);
    }
    isInitialized = true;
  };

  const getProvider = () => provider;

  return { initialize, getProvider, isInitialized: () => isInitialized };
})();

export { providerStorage };
